import { type FC, type PropsWithChildren, createElement } from 'react';

type Provider = FC<PropsWithChildren>;

export const combineProviders = (
  ...providers: [Provider, ...Provider[]]
): Provider =>
  providers.reduce((Combined, Provider) => {
    const NextProvider: FC<PropsWithChildren> = ({ children }) =>
      createElement(Combined, null, createElement(Provider, null, children));

    return NextProvider;
  });
